/**
 * This function is used to get a list of url paths for all assets in a Cache object, and is used to target the book-specific Cache object.
 * All assets in the book-specific Cache are, at the time of writing, book content such as HTML, CSS, JS, fonts, and images.
 *
 * @method getDownloadedPathsFromCache
 * @param {Cache} cache - The book-specific Cache object to query.
 * @returns {Promise<string[]>} - A list of absolute paths of all assets in the cache.
 */
const getDownloadedPathsFromCache = async (cache) => {
  if (!cache) {
    throw new Error('getDownloadedPathsFromCache: cache is required');
  }

  const requestSet = new Set();
  const requests = await cache.keys();

  requests.forEach((request) => requestSet.add(new URL(request.url).pathname));

  return requestSet;
};

export default getDownloadedPathsFromCache;
